import { render } from "./InConsoleSidebarSwitch.vue.ts?vue&type=template&id=d7be7656&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebarSwitch.vue?vue&type=template&id=d7be7656&scoped=true&ts=true"
import script from "./InConsoleSidebarSwitch.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebarSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./InConsoleSidebarSwitch.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebarSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./InConsoleSidebarSwitch.vue.scss?vue&type=style&index=0&id=d7be7656&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebarSwitch.vue?vue&type=style&index=0&id=d7be7656&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7be7656"],['__file',"src/apps/merchant3/components/in-console/ui/InConsoleSidebarSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7be7656"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7be7656', __exports__)) {
    api.reload('d7be7656', __exports__)
  }
  
  module.hot.accept("./InConsoleSidebarSwitch.vue.ts?vue&type=template&id=d7be7656&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleSidebarSwitch.vue?vue&type=template&id=d7be7656&scoped=true&ts=true", () => {
    api.rerender('d7be7656', render)
  })

}


export default __exports__